var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 360716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.411 14.6975C13.4345 14.0419 14.2468 13.1924 14.7552 12.0619C14.9137 11.7074 14.9137 11.7007 14.5373 11.7007C13.2628 11.7007 11.9883 11.7007 10.7138 11.7007C10.1393 11.7007 9.91481 11.4733 9.9082 10.9047C9.9082 10.1823 9.9082 9.45985 9.9082 8.73073C9.9082 8.17553 10.1459 7.94141 10.6874 7.94141C13.1506 7.94141 15.6137 7.94141 18.0702 7.94141C18.6712 7.94141 18.8759 8.1287 18.9419 8.73073C19.1598 10.7642 18.7636 12.664 17.7533 14.4366C16.908 15.9216 15.7392 17.0922 14.26 17.9284C13.6524 16.8514 13.0317 15.7744 12.411 14.6975Z",
    fill: "#177EE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4112 14.6972C13.0319 15.7741 13.6461 16.8511 14.2668 17.9281C13.4414 18.4899 12.5103 18.8378 11.5461 19.0251C8.06604 19.7007 5.068 18.7642 2.57845 16.1956C2.06997 15.6738 1.62753 15.0918 1.30396 14.4296C2.36713 13.8075 3.42371 13.1854 4.48689 12.5566C5.0614 13.4463 5.74817 14.2089 6.67928 14.7172C8.45565 15.7006 10.265 15.7206 12.0876 14.8443C12.1933 14.7975 12.3055 14.7507 12.4112 14.6972Z",
    fill: "#13B347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.51221 3.73277C7.63019 3.81972 6.07174 4.55553 4.90951 6.08067C4.76423 6.27465 4.63216 6.47533 4.49348 6.676C3.4303 6.05391 2.37373 5.43182 1.31055 4.80303C1.92468 3.63243 2.79636 2.68256 3.83972 1.89993C5.52364 0.635675 7.41227 -0.0131756 9.51221 0.000202751C9.51221 1.24439 9.51221 2.48858 9.51221 3.73277Z",
    fill: "#FE4C27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.31044 4.81055C2.37361 5.43264 3.43019 6.05473 4.49337 6.68352C4.12357 7.43939 3.83961 8.22203 3.76037 9.07824C3.64811 10.2555 3.89244 11.3459 4.42073 12.3827C4.45375 12.4429 4.47356 12.5031 4.49337 12.5633C3.43019 13.1854 2.37361 13.8075 1.31044 14.4363C0.696301 13.4797 0.339707 12.4228 0.148203 11.3124C-0.214995 9.17858 0.0887704 7.13838 1.0661 5.20521C1.13874 5.06474 1.23119 4.93764 1.31044 4.81055Z",
    fill: "#FED401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.51196 3.733C9.51196 2.48881 9.51196 1.24463 9.51196 0.000438658C11.6251 -0.0196289 13.5071 0.649289 15.1977 1.91354C15.376 2.04733 15.5476 2.18111 15.7127 2.32827C16.0099 2.59584 16.0561 2.97712 15.7788 3.26476C15.2043 3.87347 14.6099 4.4755 14.009 5.05746C13.7317 5.32503 13.4477 5.31165 13.1241 5.05077C12.3251 4.40861 11.427 4.01395 10.4233 3.83334C10.1261 3.77983 9.80912 3.82665 9.51196 3.733Z",
    fill: "#D84022"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.440000b0fbdb7629a1a04d069ed35e6d.svg";
export { ForwardRef as ReactComponent };